var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.barStyle)},[_c('span',{class:_vm.type},[_vm._v("\n        "+_vm._s(_vm.percentage)+"%\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }